import React, { useEffect, useState } from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import { t } from "i18next";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import {
  useCreatePromptMutation,
  useEditPromptMutation,
} from "../../api/admin/aiPromptApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const DetailPrompt = ({ prompt, onClose, createBIAS, createAnalysis }) => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const [formData, setFormData] = useState({
    name: "",
    content: "",
    type: "",
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [typeIa, setTypeIa] = useState("GPT 4o-mini");

  const typeOptions = [
    { label: t("DocumentAnalysis"), value: "DocumentAnalysis" },
    { label: t("DocumentAnalysisBIAS"), value: "DocumentAnalysisBIAS" },
    { label: t("DocumentComposition"), value: "DocumentComposition" },
    { label: t("Agent"), value: "Agent" },
  ];

  const typeIAOptions = [
    { label: "LLM IBC BETA", value: "LLM IBC BETA" },
    { label: "GPT 4o", value: "GPT 4o" },
    { label: "GPT 4o-mini", value: "GPT 4o-mini" },
    { label: "GPT 4.5", value: "GPT 4.5" },
    { label: "Gemini", value: "Gemini" },
    { label: "Claude 3.7 Sonnet", value: "Claude 3.7 Sonnet" },
    { label: "Llama 3.1", value: "Llama 3.1" },
    { label: "DeepSeek R1", value: "DeepSeek R1" },
  ];

  const typeIterOptions = [
    { label: "Singola", value: "Singola" },
    { label: "Doppia", value: "Doppia" },
    { label: "Multipla", value: "Multipla" },
  ];

  const [createPrompt, { isLoading: loadingCreate }] =
    useCreatePromptMutation();
  const [editPrompt, { isLoading: loadingEdit }] = useEditPromptMutation();

  useEffect(() => {
    if (prompt) {
      setFormData({
        name: prompt[t("Name")],
        content: prompt[t("Content")],
        type: prompt[t("Type")],
      });
    }
  }, [prompt]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = () => {
    const errors = {};
    if (!formData.name) errors.name = t("FieldRequired");
    if (!formData.type) errors.type = t("FieldRequired");
    if (!formData.content) errors.content = t("FieldRequired");
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    try {
      if (prompt) {
        const bodyEdit = {
          id: prompt.id,
          name: formData.name,
          content: formData.content,
          type: formData.type,
        };
        editPrompt(bodyEdit)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("Prompt") + " " + t("not edited"));
              return;
            } else {
              toast.success(t("PromptUpdated"));
              onClose();
            }
          });
      } else {
        const newPrompt = {
          name: formData.name,
          content: formData.content,
          type: formData.type,
        };
        createPrompt(newPrompt)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("Prompt") + " " + t("not edited"));
              return;
            }
            toast.success(t("PromptCreated"));
            onClose();
          });
      }
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <h3>{prompt ? t("EditPrompt") : t("CreatePrompt")}</h3>
      <div className=" w-2/3">
        <div className="mt-4 flex space-x-4">
          <div className="flex w-full space-x-4">
            {appConfig?.modules?.DEMO?.aiType && (
              <>
                <CoreSelectObjArr
                  name="typeIA"
                  label={"Modello AI"}
                  value={typeIa}
                  items={typeIAOptions}
                  className={"w-1/3"}
                  onChange={(e) => setTypeIa(e.target.value)}
                />
                <CoreSelectObjArr
                  name="typeIA"
                  label={"Numero Iterazioni"}
                  items={typeIterOptions}
                  className={"w-1/3"}
                />
              </>
            )}
            <CoreSelectObjArr
              name="type"
              label={t("Type")}
              value={formData.type}
              items={typeOptions}
              onChange={handleChange}
            />
          </div>
        </div>
        <CoreInputField
          className="w-full"
          label={t("Name")}
          name="name"
          onChange={handleChange}
          value={formData?.name}
          error={Boolean(validationErrors?.name)}
          helperText={validationErrors?.name}
        />
        <CoreInputField
          multiline
          rows={4}
          variant="outlined"
          className="w-full"
          label={t("Content")}
          name="content"
          onChange={handleChange}
          value={formData.content}
          error={Boolean(validationErrors.content)}
          helperText={validationErrors.content}
        />
      </div>

      <div className="flex justify-around mt-4 py-8">
        <CoreButton
          testo={loadingCreate ? t("Wait") : prompt ? t("Save") : t("Create")}
          className={`bg-primary btn-round border-primary ${
            (formData.type === "DocumentAnalysisBIAS" &&
              createBIAS &&
              !prompt &&
              "hidden") ||
            (formData.type === "DocumentAnalysis" &&
              createAnalysis &&
              !prompt &&
              "hidden")
          } `}
          onClick={handleSave}
          disabled={loadingCreate || loadingEdit}
        />
        {formData.type === "DocumentAnalysisBIAS" && createBIAS && !prompt && (
          <p className="text-bold text-red-600">
            {t("DocumentAnalysisBIAS") + " " + t("PromptCreated")}{" "}
          </p>
        )}
        {formData.type === "DocumentAnalysis" && createAnalysis && !prompt && (
          <p className="text-bold text-red-600">
            {t("DocumentAnalysis") + " " + t("PromptCreated")}{" "}
          </p>
        )}
      </div>
    </div>
  );
};

export default DetailPrompt;
